<template>
  <b-row class="custom-form-element">
    <b-col :class="'panel-content ' + additionalClasses">
      <label v-if="label" class="el">
        {{ label }}
      </label>
      <b-form-input
        :id="id"
        v-model="field"
        class="field"
        :type="type"
        :label="label"
        :placeholder="placeholder"
        :state="valid"
        :pattern="pattern"
        :maxlength="maxlength"
        :disabled="disabled"
      />
    </b-col>
  </b-row>
</template>

<script>
import {} from 'vuex';

export default {
  name: 'FormInput',
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    valid: {
      type: Boolean,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    maxlength: {
      type: String,
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    additionalClasses: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    field: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  async created() {},
  methods: {},
};
</script>

//move these to css repo
<style scoped>
.remove-right-padding {
  padding-right: 0px;
}
</style>
